module.exports = __webpack_public_path__ + "static/media/contacts-no-data.000ee363.png";